import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserProfile } from '@models/UserProfile';
import { CognitoService } from '../cognito.service';
import { SynchronizerService } from '../synchronizer.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent, ConfirmationDialogData } from '../confirmation-dialog/confirmation-dialog.component';
import { environment } from 'src/environments/environment';
import { RouterModule } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { CommonTasksService } from '../common-tasks.service';
import { MatCardModule } from '@angular/material/card';
import { HighlightedProjectsComponent } from './highlighted-projects/highlighted-projects.component';

@Component({
  selector: 'app-welcome',
  imports: [
    CommonModule,
    RouterModule,
    MatListModule,
    MatIconModule,
    MatCardModule,
    HighlightedProjectsComponent
  ],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss'
})
export class WelcomeComponent {
  constructor(
    public synchronizerService: SynchronizerService,
    public cognitoService: CognitoService,
    public dialog: MatDialog,
    public commonTasks: CommonTasksService,
  ) { }

  get user(): UserProfile | undefined {
    return this.synchronizerService.user$.value;
  }

  signUpConfirmation() {
    const data: ConfirmationDialogData = {
      title: 'Before you sign up...',
      message: 'As a reminder, we recommend that you create a username that you don\'t use other places on the internet. For further explanation, see the <a target="_blank" href="https://docs.openreadersbibles.org/security/">security</a> section of the documentation. Your username will be visible to other people, but your email address will not be.',
      yes: 'Yes, I understand',
      no: 'Dismiss'
    };
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const redirect = encodeURI(environment.cognito.redirect_uri);
        window.location.href = 'https://auth.openreadersbibles.org/signup?response_type=code&client_id=4ph7hthgr71rs0jiq6glf052g0&redirect_uri=' + redirect;
      }
    });
  }

}
